import { Link } from 'react-router-dom';
import PageHero from '../../components/PageHero';
import { pages } from '../../../config/appData';
import './TestimonialsPage.css';

function TestimonialsPage() {
  const coupleTestimonials = [
    {
      id: 1,
      quote:
        'WeddingZVenue made what seemed like an impossible task completely manageable. We found our dream farmhouse venue in Gurugram, a brilliant decorator, and our favorite photographer — all through this one platform. The process was smooth, transparent, and genuinely stress-free. Our wedding day was everything we imagined and more.',
      name: 'Ananya & Vikram Malhotra',
      role: 'Delhi · November 2024',
      rating: 5,
    },
    {
      id: 2,
      quote:
        "Planning a destination wedding in Udaipur from abroad felt terrifying. WeddingZVenue gave us a shortlist of verified vendors, helped us compare options, and connected us with a wonderful wedding planner who handled every detail on-ground. We couldn't be happier.",
      name: 'Priya & Arjun Sharma',
      role: 'NRI wedding · Udaipur · March 2024',
      rating: 5,
    },
    {
      id: 3,
      quote:
        'We had a tight budget and were worried about quality. WeddingZVenue surprised us — we found an excellent caterer and decorator who worked within our budget and delivered beyond our expectations. The platform saved us so much time and money.',
      name: 'Meghna & Rohan Joshi',
      role: 'Pune · January 2025',
      rating: 5,
    },
    {
      id: 4,
      quote:
        "The bridal makeup artist I found through WeddingZVenue was absolutely phenomenal. She understood my skin tone and aesthetic perfectly. All my wedding photos turned out beautifully. I'm so grateful I found her through this platform.",
      name: 'Nisha Kapoor',
      role: 'Mumbai · December 2024',
      rating: 5,
    },
    {
      id: 5,
      quote:
        'Finding a caterer who could handle 600 guests and manage both North Indian and South Indian menus felt impossible. WeddingZVenue helped us find the perfect caterer in Bangalore. Every single guest complimented the food!',
      name: 'Sunitha & Karthik Reddy',
      role: 'Bangalore · February 2025',
      rating: 5,
    },
  ];

  const vendorTestimonials = [
    {
      id: 'v1',
      quote:
        'Listing on WeddingZVenue has completely transformed my business. I receive genuine enquiries from couples who have already seen my portfolio and are seriously interested. The quality of leads is excellent.',
      name: 'Deepak Soni Photography',
      role: 'Jaipur · Vendor partner',
      rating: 5,
    },
  ];

  return (
    <div className="testimonials-page content-page">
      <PageHero title={pages.testimonials.title} subtitle={pages.testimonials.subtitle} />
      <div className="testimonials-container content-container">
        <p className="testimonials-intro">
          Nothing speaks louder than couples and partners who have lived the experience. Thousands of families
          across India have trusted WeddingZVenue for their most important celebrations. Here&apos;s what they
          say.
        </p>
        <h2 className="testimonials-section-title">Couples</h2>
        <div className="testimonials-list">
          {coupleTestimonials.map((t) => (
            <blockquote key={t.id} className="testimonial-card">
              <div className="testimonial-stars">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="testimonial-star" aria-hidden="true">
                    ★
                  </span>
                ))}
              </div>
              <p className="testimonial-quote">&ldquo;{t.quote}&rdquo;</p>
              <footer className="testimonial-footer">
                <cite className="testimonial-name">{t.name}</cite>
                <span className="testimonial-role">{t.role}</span>
              </footer>
            </blockquote>
          ))}
        </div>
        <h2 className="testimonials-section-title">Vendors</h2>
        <div className="testimonials-list">
          {vendorTestimonials.map((t) => (
            <blockquote key={t.id} className="testimonial-card testimonial-card--vendor">
              <div className="testimonial-stars">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="testimonial-star" aria-hidden="true">
                    ★
                  </span>
                ))}
              </div>
              <p className="testimonial-quote">&ldquo;{t.quote}&rdquo;</p>
              <footer className="testimonial-footer">
                <cite className="testimonial-name">{t.name}</cite>
                <span className="testimonial-role">{t.role}</span>
              </footer>
            </blockquote>
          ))}
        </div>
        <div className="testimonials-footer-cta">
          <p>
            Did you plan your wedding with WeddingZVenue? We&apos;d love to hear your story — help other
            couples decide with confidence.
          </p>
          <Link to="/contact" className="testimonials-cta-link">
            Share your experience
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsPage;
